// SkeletonRow.tsx — Shimmer block used while a route's primary
// data loads. Use SkeletonList for the typical N-row pattern.

interface Props {
  count?: number;
  /** True when this skeleton lives INSIDE a .console-card (matches
   *  loaded list's 8px radius + bg-primary fill + 12px top margin). */
  inset?: boolean;
}

export function SkeletonList({ count = 5, inset = false }: Props) {
  return (
    <div
      className={`console-skeleton-list${inset ? ' is-inset' : ''}`}
      aria-hidden="true"
    >
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="console-skeleton-row" />
      ))}
    </div>
  );
}

export function SkeletonDetail() {
  return (
    <div className="console-skeleton-list" aria-hidden="true">
      <div className="console-skeleton-card" />
      <div className="console-skeleton-row" />
      <div className="console-skeleton-row" />
      <div className="console-skeleton-row" />
    </div>
  );
}
